




































import { Component, Prop, Vue } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'

@Component
export default class BuilderSteps extends Vue {
  @Prop({ required: true, type: [String, Object] }) private to!: RawLocation

  @Prop({ required: true, type: [String, Number] }) private index!: string

  @Prop({ default: false, type: Boolean }) private checked!: boolean

  @Prop({ default: false, type: Boolean }) private selected!: boolean

  @Prop ({ default: false, type: Boolean }) private hidden!: boolean
}
